import { AxiosRequestConfig } from 'axios';
import { API_BASEURL } from '../../Constants';
import authAxios from '../../admin/lib/authAxios';

/**
 * Mutator using authAxios (Bearer token). Used for admin API.
 */
export const authInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  return authAxios({
    ...config,
    baseURL: API_BASEURL ?? '',
    ...options,
  }).then(({ data }) => data);
};
